import React from "react";

type TypeProps = {
  onClick?: () => void;
  style?: React.CSSProperties;
  color: string;
};

const MenuIcon = ({ onClick = () => {}, style, color }: TypeProps) => {
  return (
    <div style={style || {}} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" fill={color} />
      </svg>
    </div>
  );
};

export default MenuIcon;
